import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { FeatureFlags, useFeatureFlag } from '~/src/app/utils/featureflag';

import { BillingAccount, billingAccountService } from '../services/BillingAccountService';

export const BILLING_ACCOUNT_CACHE_KEY = 'billing_account';

export const useBillingAccount = (): UseQueryResult<BillingAccount> => {
  const alertFlag = useFeatureFlag(FeatureFlags.BFA_CALL_UPDATE_BILLING_STATUS)?.enabled ?? false;
  return useQuery({
    enabled: alertFlag,
    queryFn: billingAccountService.get,
    queryKey: [BILLING_ACCOUNT_CACHE_KEY],
    staleTime: Infinity,
  });
};
